import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { OneSignal } from 'onesignal-ngx';
import { LoginService } from 'src/app/shared/services/authservices/login.service';
import { ThemeService } from 'src/app/theme.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import Swal from 'sweetalert2';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
@Component({
  selector: 'app-new-login',
  templateUrl: './new-login.component.html',
  styleUrl: './new-login.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, ReactiveFormsModule, LottieComponent],
})
export class NewLoginComponent implements OnInit {
  loginForm: FormGroup;
  passwordVisible = false;
  showSpinner = false;
  user: any;
  roleType: any;
  usertoken: any;
  // 2FA state
  step: 'credentials' | 'setup' | 'verify' = 'credentials';
  qrCodeDataUrl: string | null = null;
  twoFaMessage = '';
  verificationCode = '';
  is2faEnabledOnLogin = false;
  tempLoginRespone: any;
  auth_key: any;
  userToken: any;
  user_two_factor_enabled: any;
  tempToken: string | null = null;
  constructor(
    private fb: FormBuilder,
    private loginservice: LoginService,
    private router: Router,
    private oneSignal: OneSignal,
    private themeService: ThemeService,
    private settings: SettingservicesService,
  ) {
    $('.top-navbar').hide();
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });


    this.usertoken = localStorage.getItem('token');
    if (this.usertoken != null) {
      this.router.navigate(['/dashboard-1'])
    }
  }


  ngOnInit(): void {
    $('#sidebar-wrapper').hide();
    $('.navbar').hide();
    $('.top-navbar').hide();
  }


  onSubmit() {
    this.showSpinner = true;
    if (this.loginForm.valid) {
      const data = this.loginForm.value
      this.loginservice.newlogin(data).then((value: any) => {
        this.showSpinner = false;
        if (value.success == true) {
          if (value?.data?.auth_verify === 1) {
            this.user_two_factor_enabled = 1;
            this.is2faEnabledOnLogin = !!value?.data?.is_2_factor_enabled;
            this.tempToken = value?.data?.temp_token || null;

            if (!this.tempToken) {
              Swal.fire({ icon: 'error', title: 'Temporary token not received from server.' });
              return;
            }

            if (this.is2faEnabledOnLogin) {
              this.step = 'verify';
            } else {
              this.step = 'setup';
              this.showSpinner = true;
              this.loginservice.setup2faWithTempToken(this.tempToken).then((res: any) => {
                this.showSpinner = false;
                if (res && res.success) {
                  this.qrCodeDataUrl = res.data?.qr_code_image_url;
                  this.twoFaMessage = res.message || '';
                } else {
                  Swal.fire({ icon: 'error', title: 'Failed to generate 2FA QR', text: res?.message || '' });
                }
              }).catch((err:any) => {
                this.showSpinner = false;
                console.error(err);
                Swal.fire({ icon: 'error', title: 'Failed to generate 2FA QR, Please reload page and try again!' });
              });
            }
          } else {
            this.prepareAuthenticatedUserState(value);
            this.navigateAfterLogin();
          }

        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/theme1/login-error.png"  alt="image" >',
            title: 'Please Use Correct Credentials',
            showConfirmButton: false,
            timer: 1500,
          });
          this.router.navigate(['/']);
        }
      })
        .catch((error: any) => {
          this.showSpinner = false;
          const errorMsg = error?.error?.message || error?.message || 'Something went wrong. Please try again later.';
          console.error('API error:', error);
          Swal.fire({
            iconHtml: '<img src="../../../../assets/theme1/login-error.png"  alt="image" >',
            title: errorMsg,
            showConfirmButton: false,
            timer: 2000,
          });
          this.router.navigate(['/']);
        });;
    } else {
      this.loginForm.markAllAsTouched();
      this.showSpinner = false;

    }
  }



  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  goToEnterCode() {
    this.step = 'verify';
  }

  async verifyCode() {
    if (!this.verificationCode || this.verificationCode.trim().length == 0) {
      Swal.fire({ icon: 'error', title: 'Enter verification code' });
      return;
    }
    this.showSpinner = true;
    try {
      if (!this.tempToken) {
        this.showSpinner = false;
        Swal.fire({ icon: 'error', title: 'Temporary token expired. Please login again.' });
        this.step = 'credentials';
        return;
      }

      const res: any = await this.loginservice.verifyLoginOtp(this.tempToken, this.verificationCode);
      this.showSpinner = false;
      if (res && res.success) {
        this.tempToken = null;
        this.prepareAuthenticatedUserState(res);
        this.navigateAfterLogin();
      } else {
        Swal.fire({ icon: 'error', title: 'You have entered invalid code!', text: res?.message || '' });
      }
    } catch (err) {
      this.showSpinner = false;
      console.error(err);
      Swal.fire({ icon: 'error', title: 'Sorry we are not able to proceed your request at the movement, try again latter.' });
    }
  }

  private prepareAuthenticatedUserState(response: any) {
    this.tempLoginRespone = response;
    this.usertoken = response?.data?.token;

    const isEmployee = JSON.stringify({
      "role_type": "Employee",
      "team_evaluation": {
        "evaluation": false,
        "data": {
          "type": "all",
          "values": {
            "view": false,
            "add": false,
            "update": false,
            "sendmail": false
          }
        }
      },
      "team_managment": {
        "team_management": false,
        "data": {
          "type": "all",
          "values": {
            "view": false,
            "update": false,
            "add": false,
            "create": false,
            "delete": false,
            "monthly_salary": false,
            "updateUser": false,
            "loanView": false,
            "loanAccept": false,
            "loanReject": false
          }
        }
      },
      "resign_data": {
        "resign": false,
        "data": {
          "type": "all",
          "values": {
            "view": false,
            "accept": false,
            "reject": false
          }
        }
      },
      "holdays_data": {
        "holidays": false,
        "data": {
          "type": "all",
          "values": {
            "view": false,
            "add": false,
            "update": false,
            "delete": false
          }
        }
      },
      "upload_data": {
        "upload_media": false,
        "data": {
          "type": "all",
          "values": {
            "view": false,
            "accept": false,
            "reject": false
          }
        }
      },
      "leave_data": {
        "leave_management": false,
        "data": {
          "type": "all",
          "values": {
            "view_leave": false,
            "accept": false,
            "reject": false,
            "update": false,
            "view_leave_report": false,
            "reset_leave": false,
            "undo_leave": false
          }
        }
      },
      "attendance_data": {
        "attentance_management": false,
        "data": {
          "type": "all",
          "values": {
            "view_attedance": false,
            "sheet": false,
            "report": false,
            "edit": false,
            "delete": false,
            "update": false
          }
        }
      },
      "event_data": {
        "event_managment": false,
        "data": {
          "type": "all",
          "values": {
            "view": false,
            "add": false,
            "edit": false,
            "delete": false
          }
        }
      },
      "account_data": {
        "account_managment": false,
        "data": {
          "type": "all",
          "values": {
            "view": false,
            "admin": false,
            "add": false,
            "edit": false,
            "delete": false,
            "export": false
          }
        }
      },
      "settings": {
        "setting": false,
        "data": {
          "type": "all",
          "values": {
            "view": false,
            "add": false,
            "edit": false,
            "delete": false
          }
        }
      }
    });

    const roleOFusers = response?.data?.user?.user_role?.user_roles;
    const isActiveRole = response?.data?.user?.user_role?.is_active;

    if (roleOFusers && isActiveRole == 1) {
      this.user = roleOFusers;
    } else {
      this.user = isEmployee;
    }

    const userRoles = JSON.parse(this.user);
    this.roleType = userRoles?.role_type;
  }


  navigateAfterLogin() {
     if (localStorage.getItem('token') == null || localStorage.getItem('token') == "") {
            localStorage.clear();
            localStorage.setItem('token', this.tempLoginRespone?.data?.token);
            localStorage.setItem('user', JSON.stringify(this.tempLoginRespone?.data?.user));
            localStorage.setItem('theme_id', this.tempLoginRespone?.data?.user?.theme_id);
            this.themeService.setThemeId();
    }
    if (this.roleType == 'Admin') {
      this.router.navigate(['/new-admin-dashboard']);
    }
    else if ((this.themeService.getThemeId() == '1' || this.themeService.getThemeId() == '2')) {
      this.router.navigate(['/dashboard-1'], { state: { role: 'user' } });
    }
    else {
      this.router.navigate(['/user-dashboard'], { state: { role: 'user' } });
    }
  }


  options: AnimationOptions = {
    path: '../../../../assets/theme1/office.json',
  };

getkeysDetail() {
    this.showSpinner = true;
    this.settings.getkeysdetail().then((value) => {
      this.auth_key = value?.data?.authenticator_key
    
      if(this.auth_key == 1){
          this.auth_key = 'true'
      }else{
          this.auth_key = 'false'
      }



      this.showSpinner = false;
    })
  }



}
